// extracted by mini-css-extract-plugin
export default {"container":"CouponsView_container__olpE6","toolbar":"CouponsView_toolbar__yds+M","title":"CouponsView_title__av6l8","searchField":"CouponsView_searchField__9l9AZ"};